


import { useEffect, useRef, useState, } from "react"
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import signupImage from '../../../../Assets/login/signup.webp'
import rightarrow from '../../../../Assets/navbar/right-arrow.svg'
import AddIcon from '@mui/icons-material/Add';
import { motion, AnimatePresence } from "framer-motion";
import { User } from 'lucide-react';
import item1 from '../../../../Assets/login/item1.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import rightArrow from '../../../../Assets/navbar/right-arrow.svg';
import axios from 'axios';
import { State, City } from "country-state-city";
import {
    ShieldCheck, UserCheck, FileText, Truck, Box, Calendar, Shield, File, X
} from "lucide-react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowLeft } from 'lucide-react';

const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

export default function AddVehiclesVendorMaster() {
    const location = useLocation();
    const fromPage = location.state?.from;
    const isWorking = location.state?.isWorking;
    const vendorDriverId = location.state?.id;
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    const [showDetails, setShowDetails] = useState(false);
    const [showOwnerDetails, setShowOwnerDetails] = useState(false);
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const navigate = useNavigate();
    const [selection, setSelection] = useState(true)
    const [isLoading, setIsLoading] = useState(true);
    const [getOwnerData, setGetOwnerData] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(false);
    const [isLoadingCities, setIsLoadingCities] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);


    const [formData, setFormData] = useState({
        typeOf: '',
        vehicleNo: '',
        driverName: "",
        driverNumber: "",
        driverEmail: "",
        licence: "",
        insuranceNo: '12312313213',
        insuranceExp: '12/03/2025',
        chassisNo: "1234567",
        engineNo: "1234566",
        make: "1234",
        model: "123",
        year: '2024',
        type: "1244",
        application: "1233",
        GVW: '1123',
        ULW: '1233',
        InsuranceName: "HDFC",
        insuranceExp: "2/03/2025"
    });

    const [ownerData, setOwnerData] = useState({
        ownerName: '',
        ownerAddress: '',
        city: '',
        state: '',
    });
    console.log('ownserdata', ownerData)
    console.log('formData', formData)

    console.log('fromPage', fromPage)
    console.log('getOwnerData', getOwnerData)


    useEffect(() => {
        loadStates();
        if (fromPage !== "/AllAddedVehicles") {
            if (getOwnerData.length > 0) {
                setOwnerData({
                    ownerName: getOwnerData[0]?.contactPerson || '',
                    ownerAddress: getOwnerData[0]?.address || "",
                    state: getOwnerData[0]?.state || "",
                    city: getOwnerData[0]?.district || ''
                });
                setFormData((prev) => ({
                    ...prev,
                    typeOf: getOwnerData[0]?.typeOf || ''
                }))
            }
            if (formData.typeOf === 'non-individual' && getOwnerData.length > 0) {
                setFormData((prev) => ({
                    ...prev,
                    driverName: '',
                    driverNumber: '',
                    driverEmail: '',
                    typeOf: 'non-individual'
                }));
            }
            if (formData.typeOf === 'individual' && getOwnerData.length > 0) {
                setFormData((prev) => ({
                    ...prev,
                    driverName: getOwnerData[0].contactPerson || '',
                    driverNumber: getOwnerData[0].contactPersonNum || '',
                    driverEmail: getOwnerData[0].email || '',
                    typeOf: 'individual'
                }));
            }
        }

    }, [formData.typeOf, getOwnerData]);

    const loadStates = () => {
        setIsLoadingStates(true);
        try {
            const allStates = State.getStatesOfCountry("IN");
            setStates(allStates);
        } catch (error) {
            console.error('Error loading states:', error);
            setStates([]);
        } finally {
            setIsLoadingStates(false);
        }
    }

    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        try {
            const allCities = City.getCitiesOfState("IN", stateCode);
            setCities(allCities);
        } catch (error) {
            console.error('Error loading cities:', error);
            setCities([]);
        } finally {
            setIsLoadingCities(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, files, type } = e.target;
        let formattedValue = value; // Initialize formattedValue with the original value
        console.log('name', name)
        console.log('value', value)

        if (name === 'vehicleNo') {
            formattedValue = name === 'vehicleNo' ? value.toUpperCase() : value;
            // const vehicleNoRegex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/;
            const vehicleNoRegex = /^[a-zA-Z]{2}[0-9]{1,2}[a-zA-Z]{1,3}[0-9]{4}$/;

            if (vehicleNoRegex.test(value.toUpperCase())) {
                handleVehicleSearch();
            }
        }

        // Validation for specific fields
        if (name === 'licence') {
            formattedValue = name === 'licence' ? value.toUpperCase() : value;

        }
        if (name === 'driverEmail') {
            // const error = validateEmail(value);
            // setErrors((prevErrors) => ({
            //     ...prevErrors,
            //     driverEmail: error,
            // }));
        }

        // Always update form data
        setFormData((prevState) => ({
            ...prevState,
            [name]: formattedValue,
        }));

        if (value.length > 6) {
            // setMockFormData(value)
        }


        // console.log('final form: ', formData);
    };

    const handleOwnerChange = (e) => {
        const { name, value } = e.target;
        if (name === 'state') {
            loadCities(value);
        }// Load cities when state changes
        setOwnerData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const validateForm = () => {
        const { typeOf, vehicleNo, driverName, driverNumber, driverEmail, licence } = formData;
        if (!typeOf || !vehicleNo || !driverName || !driverNumber || !driverEmail || !licence) {
            console.log("typeOf, vehicleNo, driverName, driverNumber, driverEmail, licence", typeOf, vehicleNo, driverName, driverNumber, driverEmail, licence)
            toast.error('Please fill all vehicle details!');
            return false;
        }
        if (!ownerData.ownerName || !ownerData.ownerAddress || !ownerData.city || !ownerData.state) {
            toast.error('Please click on the Owner button and fill all owner details!');
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (fromPage !== "/AllAddedVehicles") {
            const fetchData = async () => {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendor/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
                    setGetOwnerData(response.data.data); // Save the fetched data
                    setIsLoading(false); // Set loading to false
                    console.log("Fetched data:", response.data.data); // Log the fetched data
                } catch (err) {
                    console.error("Error fetching data:", err);
                    setIsLoading(false); // Set loading to false even if there's an error
                }
            };

            fetchData();
        }

        if (fromPage === "/AllAddedVehicles") {
            const fetchData = async () => {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriverInfo/${vendorDriverId}`, { headers: { Authorization: `Bearer ${token}` } });
                    setGetOwnerData(response.data.data); // Save the fetched data
                    console.log('response.data.data', response.data.data)
                    setOwnerData((prevState) => ({
                        ...prevState,
                        ownerName: response.data.data[0]?.ownerName || '',
                        ownerAddress: response.data.data[0]?.ownerAddress || '',
                        state: response.data.data[0]?.state || '',
                        city: response.data.data[0]?.city || '',
                    }))
                    setFormData((prevState) => ({
                        ...prevState,
                        vehicleNo: response.data.data[0]?.vehicleNo || '',
                        driverName: response.data.data[0]?.driverName || '',
                        driverNumber: response.data.data[0]?.driverNumber || '',
                        driverEmail: response.data.data[0]?.driverEmail || '',
                        licence: response.data.data[0]?.licence || '',
                        typeOf: response.data.data[0]?.typeOf || '',
                    }))
                    setIsLoading(false); // Set loading to false
                    console.log("Fetched data:", response.data.data); // Log the fetched data
                } catch (err) {
                    console.error("Error fetching data:", err);
                    setIsLoading(false); // Set loading to false even if there's an error
                }
            };

            fetchData();
        }

    }, []);

    const getLoginDriver = async () => {
        try {
            const phoneNumber = localStorage.getItem('phoneNumber');
            const phoneNumberIv = localStorage.getItem('phoneNumberIv');
            const otp = localStorage.getItem('otp');
            const otpIv = localStorage.getItem('otpIv');

           const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/loginDriver`,
                {
                    phoneNumber: phoneNumber,
                    phoneNumberIv: phoneNumberIv,
                    otp: otp,
                    otpIv: otpIv,
                }
            );
            console.log('respose', response)
            if (response.status === 200) {
                console.log('done')
                if (response.data.data.vendorDriverCode) {
                    console.log("userRole", "vendorDriver");
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("userId", response.data.userId);
                    localStorage.setItem("loginId", response.data.loginId);
                    localStorage.setItem("loginTime", Date.now());
                    document.cookie = `token=${response.data.token}; path=/; max-age=${48 * 60 * 60
                      }; secure; samesite=strict`;            
                    localStorage.setItem("userRole", "vendorDriver");
                    localStorage.setItem("userType", response.data.data.VendorType);
                    return;
                  }
            }
        } catch (error) {
            console.log(error);
            return
        }
}


const handleContinue = async () => {
    if (validateForm()) {
        // Combine formData and ownerData into one object
        const payload = {
            ...formData,
            ...ownerData,
        };
        console.log('data', payload)
        toast.success('All details are valid ! Proceeding...');
        try {
            // Make the API call
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/addNewVehicleVendor/${userId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });


            if (response.ok) {
                const data = await response.json();
                toast.success('Vehicle added successfully!');
                console.log('Response from server:', data);
                if (formData.typeOf === 'individual') {
                   await getLoginDriver();
                    navigate('/crane-driver-home')
                }
            } else {
                const errorData = await response.json();
                toast.error(`Failed to add vehicle: ${errorData.message || 'Unknown error'}`);
                console.error('Error response from server:', errorData);
            }
        } catch (error) {
            toast.error('An error occurred while adding the vehicle.');
            console.error('Error:', error);
        }
    }
};

const handleUpdate = async () => {
    if (validateForm()) {
        // Combine formData and ownerData into one object
        const payload = {
            ...formData,
            ...ownerData,
        };
        console.log('data', payload)

        toast.success('All details are valid ! Proceeding...');
        try {
            // Make the API call
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/updateDriverInfoVendor/${vendorDriverId}/${vendorDriverId}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-type': `application/json`
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const data = await response.json();
                toast.success('Vehicle updated successfully!');
                console.log('Response from server:', data);

                navigate('/AllAddedVehicles')
            } else {
                const errorData = await response.json();
                toast.error(`Failed to add vehicle: ${errorData.message || 'Unknown error'}`);
                console.error('Error response from server:', errorData);
            }
        } catch (error) {
            toast.error('An error occurred while adding the vehicle.');
            console.error('Error:', error);
        }
    }
};

const isOwnerDetailsComplete = Object.values(ownerData).every((value) => value.trim() !== '');


const handleOwnerDetails = async () => {
    setShowOwnerDetails(!showOwnerDetails); // show animation
};




const ownerDetailsRef = useRef();
const handleOutsideClick1 = (e) => {
    if (ownerDetailsRef.current && !ownerDetailsRef.current.contains(e.target)) {
        setShowOwnerDetails(false);
    }
};

useEffect(() => {
    if (showOwnerDetails) {
        document.addEventListener('mousedown', handleOutsideClick1);
    } else {
        document.removeEventListener('mousedown', handleOutsideClick1);
    }

    return () => {
        document.removeEventListener('mousedown', handleOutsideClick1);
    };
}, [showOwnerDetails]);


const handleOrderDetails = async () => {
    setShowOrderDetails(!showOrderDetails); // show animation
};




const OrderDetailsRef = useRef();
const handleOutsideClick2 = (e) => {
    if (OrderDetailsRef.current && !OrderDetailsRef.current.contains(e.target)) {
        setShowOrderDetails(false);
    }
};

useEffect(() => {
    if (showOrderDetails) {
        document.addEventListener('mousedown', handleOutsideClick2);
    } else {
        document.removeEventListener('mousedown', handleOutsideClick2);
    }

    return () => {
        document.removeEventListener('mousedown', handleOutsideClick2);
    };
}, [showOrderDetails]);



const handleVehicleSearch = async () => {
    setShowDetails(!showDetails); // show animation
};

const detailsRef = useRef();
const handleOutsideClick = (e) => {
    if (detailsRef.current && !detailsRef.current.contains(e.target)) {
        setShowDetails(false);
    }
};

useEffect(() => {
    if (showDetails) {
        document.addEventListener('mousedown', handleOutsideClick);
    } else {
        document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
    };
}, [showDetails]);

return (

    <div className='min-h-screen bg-white'>
        {/* <Navbar/> */}
        <ToastContainer />
        <div className=" w-full rounded-[30px] bg-white md:pb-[70px] md:px-[56px] px-2 mx-auto">
            <div onClick={() => navigate(-1)} className='fixed top-6 left-3'>
                <ArrowLeft className="text-black" />
            </div>
            <div className="container-fluid ">

                <div className="flex items-center justify-center md:flex-row flex-col-reverse  gap-[1%] md:pr-[2%] pr-0">
                    <div className='max-w-[862px] md:block hidden w-full'>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/signup.webp' alt="" />
                    </div>
                    <div className='max-w-[430px] w-full '>

                        {!isLoading && (
                            <div className="flex flex-col gap-[9.6vw] mb-[5rem] md:gap-[42px] ">
                                <div className="mt-5 flex items-center gap-2 pt-6 px-2">
                                    <AppRegistrationIcon className="text-[#21A6E9]" />
                                    {fromPage !== "/AllAddedVehicles" && (<h6 className="text-[20px]  md:text-[28px] font-[500] font-satoshi text-[#000000]">
                                        Enter Registration Number
                                    </h6>)}
                                    {fromPage == "/AllAddedVehicles" && (<h6 className="text-[20px]  md:text-[28px] font-[500] font-satoshi text-[#000000]">
                                        View Details
                                    </h6>)}
                                </div>

                                <div className="relative flex gap-3 items-center justify-end w-full ml-auto text-right">
                                    {(fromPage !== "/AllAddedVehicles" && location.state?.value !== 'additional-vehicles') && (
                                        <div className="flex gap-3 mb-3 w-full">

                                            <label className="flex font-satoshi flex-row items-center gap-[0.3rem] cursor-pointer text-gray-700 text-[14px] font-medium">
                                                <input
                                                    type="radio"
                                                    className="w-5 h-5 accent-[#21A6E9] focus:ring-2 focus:ring-[#21A6E9] cursor-pointer"
                                                    name="flexRadioDefault"
                                                    onChange={() => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            driverName: '',
                                                            driverEmail: '',
                                                            driverNumber: '',
                                                            typeOf: 'non-individual',

                                                        }));
                                                    }}
                                                />
                                                <p className="text-[14px]">Company</p>
                                            </label>
                                            <label className="flex font-satoshi flex-row items-center gap-2 cursor-pointer text-gray-700 text-[14px] font-medium">
                                                <input
                                                    type="radio"
                                                    className="w-5 h-5 accent-[#21A6E9] focus:ring-2 focus:ring-[#21A6E9] cursor-pointer"
                                                    name="flexRadioDefault"
                                                    onChange={() =>
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            driverName: getOwnerData[0].contactPerson || '',
                                                            driverNumber: getOwnerData[0].contactPersonNum || '',
                                                            driverEmail: getOwnerData[0].email || '',
                                                            typeOf: 'individual',
                                                        }))
                                                    }
                                                />
                                                <p className="text-[14px]">Individual</p>
                                            </label>
                                        </div>)}
                                    {isWorking && (<button
                                        onClick={() => { setShowOrderDetails(!showOrderDetails) }}
                                        // style={{ border: '1px solid #21A6E9' }}
                                        className="block font-[500] font-satoshi p-1 py-2 rounded-[20%] text-[15px] text-[#000000] hover:text-[#21A6E9] focus:outline-none underline focus:ring-2 focus:ring-[#21A6E9] transition-all duration-200 ease-in-out"
                                    >
                                        View Order Details
                                    </button>)}
                                    <button
                                        onClick={() => { setShowOwnerDetails(!showOwnerDetails) }}
                                        className="block font-[500] font-satoshi text-[15px] flex flex-col justify-center items-center text-[#000000] "
                                    >
                                        <User className="text-[#21A6E9]" />
                                        <p className="text-center">Owner</p>
                                    </button>

                                </div>
                                <div>
                                    <label htmlFor="" className='font-[500] font-satoshi text-[15px] text-[#000000] mb-0 pb-[13px]'>Vehicle Registration No</label>
                                    <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                        <img src='https://www.svgrepo.com/show/341486/vehicle-tracking-vehicle-tracking-iot-transportation-internet-of-things-connected-vehicle.svg' alt="" className="w-[20px] h-[20px]" />
                                        <input
                                            type="text"
                                            id="vehicleNo"
                                            name="vehicleNo"
                                            required
                                            value={formData.vehicleNo}
                                            onChange={handleChange}
                                            readOnly={fromPage === "/AllAddedVehicles"}
                                            className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                            placeholder="Enter your vehicle number"
                                        />

                                    </div>
                                    <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[15px] text-[#000000] mb-0 pb-[13px]'>Driver Name</label>
                                    <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                        <img src='https://www.svgrepo.com/show/483503/registration-pictogram-2.svg' alt="" className="w-[20px] h-[20px]" />
                                        <input
                                            type="text"
                                            id="driverName"
                                            name="driverName"
                                            required
                                            value={formData.driverName}
                                            onChange={handleChange}
                                            className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                            placeholder="Enter Driver Name"
                                        />
                                    </div>
                                    <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[15px] text-[#000000] mb-0 pb-[13px]'>Driver Mobile No</label>
                                    <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                        </svg>
                                        <input
                                            type="text"
                                            id="driverNumber"
                                            name="driverNumber"
                                            required
                                            value={formData.driverNumber}
                                            onChange={handleChange}
                                            className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                            placeholder="Enter Number"
                                        />
                                    </div>
                                    <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[15px] text-[#000000] mb-0 pb-[13px]'>Driver Email</label>
                                    <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item1.svg' alt="" className="w-[20px] h-[20px]" />
                                        <input
                                            type="text"
                                            id="driverEmail"
                                            name="driverEmail"
                                            required
                                            value={formData.driverEmail}
                                            onChange={handleChange}
                                            className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                            placeholder="Enter your Email"
                                        />
                                    </div>
                                    <label htmlFor="" className='mt-[10%] font-[500] font-satoshi text-[15px] text-[#000000] mb-0 pb-[13px]'>Driver Licence</label>
                                    <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item1.svg' alt="" className="w-[20px] h-[20px]" />
                                        <input
                                            type="text"
                                            id="licence"
                                            name="licence"
                                            required
                                            value={formData.licence}
                                            onChange={handleChange}
                                            className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                            placeholder="Enter Licence No"
                                        />
                                    </div>


                                </div>

                            </div>
                        )}

                        {fromPage !== "/AllAddedVehicles" && (
                            <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                    <button
                                        onClick={handleContinue}

                                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${selection === true
                                            ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                            : "bg-[#a7dbf5] cursor-not-allowed"
                                            }`}
                                    >
                                        Add Vehicle
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
                                    </button>
                                    <button
                                        onClick={() => { navigate("/AllAddedVehicles") }}
                                        className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                    >
                                        View
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                    </button>

                                    <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                </div>
                            </div>
                        )}
                        {fromPage === "/AllAddedVehicles" && (
                            <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                    <button
                                        onClick={handleUpdate}

                                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${selection === true
                                            ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                            : "bg-[#a7dbf5] cursor-not-allowed"
                                            }`}
                                    >
                                        Update Details
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
                                    </button>
                                    <button
                                        onClick={() => navigate('/HistoryDriverPage', { state: { from: '/AddVehiclesVendorMaster', id: vendorDriverId, vehicleNo: getOwnerData[0].vehicleNo } })}
                                        className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                    >
                                        History
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                    </button>

                                    <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                </div>
                            </div>


                        )}


                    </div></div>

                <AnimatePresence>
                    {showDetails && (
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 50 }}
                            transition={{ duration: 0.4 }}
                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                        >
                            <div ref={detailsRef} className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]">

                                {/* Close Button */}
                                <button
                                    onClick={() => setShowDetails(false)}
                                    className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                                >
                                    <X size={24} />
                                </button>

                                <h2 className="text-xl font-semibold mb-4 font-satoshi text-[#000]">Vehicle Details</h2>

                                <div className="grid grid-cols-2 md:grid-cols-2 gap-4">

                                    {/* Chassis No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <FileText size={16} />
                                                Chassis No
                                            </span>
                                        </label>


                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.chassisNo}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Engine No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Truck size={16} />
                                                Engine No
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.engineNo}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Make */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Box size={16} />
                                                Make
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.make}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Model */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Box size={16} />
                                                Model
                                            </span>

                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.model}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Year */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Calendar size={16} />
                                                Year
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.year}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* GVW */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">

                                                <Shield size={16} />
                                                GVW
                                            </span>

                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.GVW}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Insurer Name */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                            <span className="flex items-center gap-1">
                                                <FileText size={16} />
                                                Insurer Name
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.InsuranceName}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Insurance Valid Upto */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                            <span className="flex items-center gap-1">
                                                <Calendar size={16} className="inline-block mr-1" />
                                                Insurance Valid Upto
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value={formData.insuranceExp}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </motion.div>
                    )}

                    {showOwnerDetails && (
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 50 }}
                            transition={{ duration: 0.4 }}
                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                        >
                            <div ref={ownerDetailsRef} className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]">

                                {/* Close Button */}
                                <button
                                    onClick={() => setShowOwnerDetails(false)}
                                    className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                                >
                                    <X size={24} />
                                </button>

                                <h2 className="text-xl font-semibold mb-4 font-satoshi text-[#000]">Owner Details</h2>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Chassis No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <FileText size={16} />
                                                Owner Name
                                            </span>
                                        </label>


                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1 border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                            <input
                                                type="text"
                                                id="ownerName"
                                                name="ownerName"
                                                readOnly={fromPage === "/AllAddedVehicles"}
                                                value={ownerData.ownerName}
                                                onChange={handleOwnerChange}

                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Engine No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Truck size={16} />
                                                Owner State
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1 border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                            <select
                                                name="state"
                                                onChange={handleOwnerChange}
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                disabled={isLoadingStates || fromPage === "/AllAddedVehicles"}
                                                value={ownerData.state}>
                                                <option value="">Select State</option>
                                                {states.map(state => (
                                                    <option key={state.iso2} value={state.iso2}>{state.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Box size={16} />
                                                Owner City
                                            </span>

                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1 border-b-[2px] border-solid border-[#000000] h-[40px] box-border">


                                            <select
                                                name="city"
                                                value={ownerData.city} // This should match city.iso2
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                                onChange={handleOwnerChange}
                                                disabled={isLoadingCities || !ownerData.state}
                                            >
                                                <option value="">Select City</option>
                                                {!cities.error && cities.map(city => (
                                                    <option key={city.iso2} value={city.name}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Make */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1 ">
                                                <Box size={16} />
                                                Owner Address
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2  border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                            <input
                                                type="text"
                                                readOnly={fromPage === "/AllAddedVehicles"}
                                                id="ownerAddress"
                                                name="ownerAddress"
                                                value={ownerData.ownerAddress}
                                                onChange={handleOwnerChange}

                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => setShowOwnerDetails(false)}
                                        disabled={!isOwnerDetailsComplete}
                                        className={`mt-4 w-full py-3 rounded-lg font-semibold ${isOwnerDetailsComplete
                                            ? 'bg-[#21A6E9] text-white'
                                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                            }`}
                                    >
                                        Save Owner Details
                                    </button>




                                </div>
                            </div>
                        </motion.div>
                    )}

                    {showOrderDetails && (
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 50 }}
                            transition={{ duration: 0.4 }}
                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                        >
                            <div ref={OrderDetailsRef} className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]">

                                {/* Close Button */}
                                <button
                                    onClick={() => setShowOrderDetails(false)}
                                    className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                                >
                                    <X size={24} />
                                </button>

                                <h2 className="text-xl font-semibold mb-4 mt-4 font-satoshi text-[#000]">Order Details</h2>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Chassis No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <FileText size={16} />
                                                Request Raised
                                            </span>
                                        </label>


                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value="12/03/2023 12:00 PM"
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Engine No */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Truck size={16} />
                                                Request Accepted
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value="12/03/2023 12:01 PM"
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>

                                    {/* Make */}
                                    <div>
                                        <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                            <span className="flex items-center gap-1">
                                                <Box size={16} />
                                                Current State
                                            </span>
                                        </label>
                                        <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                            <input
                                                readOnly
                                                value='Ready To Work'
                                                className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                            />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>








            </div>
        </div>

    </div>
)

}